import * as React from 'react';
import { OwnProps } from '@websky/core/src/Checkout/components/Checkout/routes/Order';
import ServicesAggregationPage from '@websky/core/src/Checkout/components/Checkout/ServicesAggregationPage/ServicesAggregationPage';
import { EngineTheme as EveryTravelTheme } from '@websky/every-travel/src/theme';
import Explore from '../../../theme/everyTravel/Explore/Explore.css';
import SearchForm from '../../../theme/everyTravel/SearchForm/SearchForm.css';
import ProductCard from '../../../theme/everyTravel/ProductCard/ProductCard.css';
import FullScreenModal from '../../../theme/everyTravel/FullScreenModal/FullScreenModal.css';
import ExcursionSearchForm from '../../../theme/everyTravel/ExcursionSearchForm/ExcursionSearchForm.css';
import { SearchFormTheme } from '@websky/every-travel/src/Widget/CostaBrava/CostaBrava';

const everyTravelStyles: EveryTravelTheme = {
	Initial: {
		Initial: {
			initial: Explore.initial
		}
	},
	Explore: {
		Explore: {
			wrapper: Explore.wrapper
		},
		SearchForm: {
			title: Explore.searchForm__title
		}
	},
	ProductCard: {
		ProductCard: {
			freeCancel: ProductCard.freeCancel,
			change: ProductCard.change,
			title: ProductCard.title,
			card_selected: ProductCard.card_selected,
			selected: ProductCard.selected,
			price: ProductCard.price
		},
		Option: {
			item: ProductCard.option__item
		}
	},
	FullscreenModal: {
		FullscreenModal: {
			cart: FullScreenModal.cart
		}
	}
};

const searchFormStyles: SearchFormTheme = {
	SearchForm: {
		SearchForm: {
			wrapper: SearchForm.wrapper,
			inputTab: SearchForm.inputTab,
			input: SearchForm.input
		},
		ExcursionSearchForm: {
			filtersRanges__item: ExcursionSearchForm.filtersRange__item,
			filtersType__title: ExcursionSearchForm.filtersType__title,
			categories__list: ExcursionSearchForm.categories__list
		}
	},
	Calendar: {
		Calendar: {
			calendar: SearchForm.calendar
		}
	}
};

const Order: React.FC<OwnProps> = props => {
	return (
		<ServicesAggregationPage
			{...props}
			userInfo={props.userInfo}
			refetchUser={props.refetchUser}
			setNextStep={props.setNextStep}
			currentStep={props.currentStep}
			goToExchange={props.goToExchange}
			goToRefund={props.goToRefund}
			goToChangePassenger={props.goToChangePassenger}
			everyTravelStyles={everyTravelStyles}
			everyTravelSearchFormStyles={searchFormStyles}
		/>
	);
};

export default Order;
